export const dayCountConventionOptions = [
  { value: 'ThirtyOver360', label: '30/360', description: '' },
  { value: 'ActualOver360', label: 'Act/360', description: '' },
  { value: 'ActualOver365', label: 'Act/365', description: '' },
  { value: 'ActualICMA', label: 'Act/Act-ICMA', description: '' },
  { value: 'ThirtyOver360SE', label: '30E/360 (SE)', description: '' },
  { value: 'ThirtyOver360Eurobond', label: '30E/360', description: '' },
];
